import { config, handleResponse } from '../../_helpers';

export const roleService = {
    getActiveRoles,
    getAllRoles,
    getRoleById,
    updateRole,
    createRole,
    searchRole,
    deleteRole,
    activation,
    multipleInsert
};

function getActiveRoles() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Roles/getIsActive`, requestOptions).then(handleResponse);
}

function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/Roles/activation/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}

function getAllRoles(skip, take) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Roles/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/roles/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
}

function getRoleById(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Roles/get/${id}`, requestOptions).then(handleResponse);
}

function updateRole(role, roleDetail, profile) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(
            [{
                tblRoles: {
                    roleId: role.roleId,
                    roleName: role.roleName,
                    isDat: role.isDat,
                    userModified: profile.userId
                },
                tblRoleDetails: roleDetail
            }]
            //     {
            //     roleId: role.roleId,
            //     roleName: role.roleName,
            //     isActive: role.isActive,
            //     userModified: profile.userId
            // }
        ),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Roles/update/${role.roleId}`, requestOptions).then(handleResponse);
}

function createRole(role, userProfile) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            roleId: role.roleId,
            roleName: role.roleName,
            userCreated: userProfile.userId
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Roles`, requestOptions).then(handleResponse);
}

function deleteRole(id) {

    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Roles/delete`, requestOptions).then(handleResponse);
}

function searchRole(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Roles/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
}

function multipleInsert(role, roledetail, userProfile) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(
            [{
                tblRoles: {
                    roleId: role.roleId,
                    roleName: role.roleName,
                    isDat: role.isDat,
                    userCreated: userProfile.userId
                },
                tblRoleDetails: roledetail
            }]
        ),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Roles/multipleInsert`, requestOptions).then(handleResponse);
}